import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Toaster } from '@/components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Users from './pages/Users';
import MailConfigs from './pages/MailConfigs';
import Batches from './pages/Batches';
import SendBatches from './pages/SendBatches';
import SendBatchDetail from './pages/SendBatchDetail';
import ApiDocs from './pages/ApiDocs';
import AuditLogs from './pages/AuditLogs';
import Layout from './components/Layout';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me')
        .then(res => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('token');
          setUser(null);
        });
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login setUser={setUser} />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <Dashboard user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/companies" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <Companies user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <Users user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/mail-configs" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <MailConfigs user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/batches" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <Batches user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/send-batches" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <SendBatches user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/send-batches/:id" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                <SendBatchDetail user={user} />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/api-docs" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                {user?.role === 'superadmin' ? <ApiDocs user={user} /> : <Navigate to="/" replace />}
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/audit-logs" element={
            <ProtectedRoute>
              <Layout user={user} setUser={setUser}>
                {user?.role === 'superadmin' ? <AuditLogs user={user} /> : <Navigate to="/" replace />}
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
